module.exports = __webpack_public_path__ + "static/media/mode-73.38a2c4fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-73.svg
// module id = 1038
// module chunks = 2